/* eslint-disable no-unused-vars */
import _ from "lodash";
import React, { useEffect } from "react";
import { GetActiveIdentityUser, GetActiveRole } from "../../../axios";
import { Button, FormCheckBox, FormDropDown } from "../../../components";
import LoaderComponent from "../../../components/common/Loader";
import { colors } from "../../../configs";
import Strings from "../../../translations";

const CreateUserRoleMappingForm = (props) => {
  const {
    errorMessage,
    setMessage,
    handleResultData,
    actionType,
    initialValue = {},
    handleModalClose,
  } = props;

  // console.log("^^^^^^^^^^^^^^",initialValue)

  const [initialRoles] = React.useState([]);
  const [roles, setRoles] = React.useState([]);
  const [user, setUser] = React.useState({
    value: initialValue.id ? initialValue.id : "",
    error: false,
    success: false,
  });
  const [options, setOptions] = React.useState([]);
  const [loading, setLoading] = React.useState(false);


  useEffect(() => {
    setLoading(true);
    GetActiveIdentityUser()
      .then((res) => {
        setLoading(false);
        const allData = res.data.data;
        const result = allData.map((ele) => ({
          key: ele.id,
          value: ele.id,
          label: ele.email,
        }));
        setOptions(result);
      })
      .catch((e) => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    setLoading(true);
    if (actionType === "add") {
      GetActiveRole()
        .then((res) => {
          setLoading(false);
          let allData = res.data.data;
          const result = allData.map((elm) => ({
            key: elm.id,
            functionName: elm.name,
            checked: false,
          }));
          setRoles(result);
        })
        .catch((e) => {
          setLoading(false);
        });
    }
  }, [actionType]);

  useEffect(() => {
    setLoading(true);
    if (actionType === "edit") {
      const arr = initialValue?.roles;
      const checkArr = { checked: true };
      if(arr){
        for (let i = 0; i < arr?.length; i++) {
          arr[i] = Object.assign(arr[i], checkArr);
        }
      }
      var item_id_list = [];
      const result = arr.map((ele) => item_id_list.push(ele.id));
      GetActiveRole()
        .then((res) => {
          setLoading(false);
          const fetchData = res.data.data.map((ele) => ({
            key: ele.id,
            functionName: ele.name,
            checked: item_id_list.includes(ele.id) ? true : false,
          }));
          setRoles(fetchData);
        })
        .catch((e) => {
          setLoading(false);
        });
    }
  }, [actionType]);

  const handleChangeCheck = (key) => {
    const result = roles.map((functionName) => {
      if (functionName.key === key) {
        return {
          ...functionName,
          checked: !functionName.checked,
        };
      } else {
        return {
          ...functionName,
        };
      }
    });
    setRoles(result);
  };

  const handleSelectDropDown = (value) => {
    setMessage(null);
    setUser(value);
  };

  const functionResultTrue = (roles) => {
    const resultArray = [];
    roles.forEach((func) => {
      if (func.checked === true) {
        resultArray.push(func.key);
      }
    });
    return resultArray;
  };

  const handleSaveData = () => {
    const formData = {
      identity_id: user.value,
      role_id: functionResultTrue(roles),
    };
    handleResultData(formData);
  };

  const disable =
    user.value === "" ||
    user.error ||
    user.success === false ||
    roles.every((functionName) => {
      return !functionName.checked;
    });

  const editDisable =
    initialValue.user === user.value && _.isEqual(roles, initialRoles);

  const pageHeader = Strings["UserRoleMapping.createUserRoleMappingHeader"],
    editpageHeader = Strings["UserRoleMapping.editUserRoleMappingHeader"],
    dropdownLabel =
      Strings["UserRoleMapping.createUserRoleMappingDropdownLabel"],
    dropdownCustomError =
      Strings["UserRoleMapping.createUserRoleMappingDropdownCustomError"],
    selectText = Strings["UserRoleMapping.createUserRoleMappingSelectText"],
    selctRoleHeader =
      Strings["UserRoleMapping.createUserRoleMappingSelectRoleHeader"],
    SaveButton = Strings["UserRoleMapping.createUserRoleMappingSaveButton"],
    UpdateButton = Strings["UserRoleMapping.createUserRoleMappingUpdateButton"],
    cancelButton = Strings["UserRoleMapping.createUserRoleMappingCancelButton"];

  return (
    <div className="modalFormContainer">
      {loading ? <LoaderComponent /> : null}
      {errorMessage && <h6 style={{ color: "red" }}>{errorMessage}</h6>}
      <h2>{actionType === "add" ? pageHeader : editpageHeader}</h2>
      <FormDropDown
        selectText={selectText}
        Label={dropdownLabel}
        Options={options}
        value={user.value}
        onSelect={handleSelectDropDown}
        customErrorLine={dropdownCustomError}
        searchable={false}
        isMulti={false}
        disable={actionType !== "add" ? true : false}
        starProps={true}
        isValidate={true}
      />
      <br />
      <h4>
        {selctRoleHeader}
        <span className="text-danger">*</span>
      </h4>
      <div className={"row"}>
        {roles.map((functionName) => {
          return (
            <div className={"col-12 col-md-3"}>
              <FormCheckBox
                starProps={true}
                key={functionName.key}
                Label={functionName.functionName}
                checked={functionName.checked}
                handleChangeCheck={() => handleChangeCheck(functionName.key)}
              />
            </div>
          );
        })}
      </div>

      <div className="row deleteFunction__buttongroup">
        <div style={{ display: "flex", marginTop: "30px" }}>
          <Button
            buttonName={actionType === "add" ? SaveButton : UpdateButton}
            disable={actionType === "add" ? disable : editDisable}
            onClick={handleSaveData}
            buttonStyle={{ backgroundColor: colors.primary }}
          />
          <Button
            buttonName={cancelButton}
            onClick={() => {
              handleModalClose();
              setMessage(null);
            }}
            buttonStyle={{
              backgroundColor: colors.darkgrey,
              marginLeft: "10px",
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default CreateUserRoleMappingForm;
